export default "__VITE_ASSET__DuabTszy__"